/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const {HeroFlex, HeroGlass, LoginBox, HeroBar, BarItem, Content, RatesList, RatesCategory, RateCard, Row, Column, Markup, Jumbotron, VideoPullquote, CardDeck, Card, Schema} = Object.assign({}, _provideComponents(), props.components);
  if (!BarItem) _missingMdxReference("BarItem", true);
  if (!Card) _missingMdxReference("Card", true);
  if (!CardDeck) _missingMdxReference("CardDeck", true);
  if (!Column) _missingMdxReference("Column", true);
  if (!Content) _missingMdxReference("Content", true);
  if (!HeroBar) _missingMdxReference("HeroBar", true);
  if (!HeroFlex) _missingMdxReference("HeroFlex", true);
  if (!HeroGlass) _missingMdxReference("HeroGlass", true);
  if (!Jumbotron) _missingMdxReference("Jumbotron", true);
  if (!LoginBox) _missingMdxReference("LoginBox", true);
  if (!Markup) _missingMdxReference("Markup", true);
  if (!RateCard) _missingMdxReference("RateCard", true);
  if (!RatesCategory) _missingMdxReference("RatesCategory", true);
  if (!RatesList) _missingMdxReference("RatesList", true);
  if (!Row) _missingMdxReference("Row", true);
  if (!Schema) _missingMdxReference("Schema", true);
  if (!VideoPullquote) _missingMdxReference("VideoPullquote", true);
  return React.createElement(React.Fragment, null, React.createElement(HeroFlex, null, React.createElement(HeroGlass, {
    backgroundSrc: "/hero/glass/hero-homepage-daves-mystyle.jpg",
    heroTitle: "Make MyStyle® Your Lifestyle",
    heroSubTitle: "Why Mountain America?",
    heroBody: "<p>Everyone needs a checking account. So get the one with built-in lifelines made just for you, including loan rate discounts and mobile phone protection.</p>",
    heroFooter: "<div><a class=\"btn btn-light mr-4 mb-3\" href=\"/accounts/checking/mystyle-checking\">Learn more</a><a class=\"btn btn-outline-light mb-3\" href=\"https://secure.macu.com/#/signup?loanType=ACCOUNT_OPENING&amp;productId=B52\">Join today</a></div>",
    adobeWait: "0",
    placeholderSrc: "/Images/e4e5e6-pixel.png",
    backgroundAlt: "Dave working on a car"
  }, React.createElement(LoginBox), React.createElement(HeroBar, {
    title: "WHAT CAN WE HELP YOU WITH?",
    adobeWait: "0"
  }, React.createElement(BarItem, {
    label: "LOG IN",
    link: "https://o.macu.com"
  }), React.createElement(BarItem, {
    label: "RATES",
    link: "/rates"
  }), React.createElement(BarItem, {
    label: "ACCOUNTS",
    link: "/accounts"
  }), React.createElement(BarItem, {
    label: "LOANS",
    link: "/loans"
  }), React.createElement(BarItem, {
    label: "BECOME A MEMBER",
    link: "https://secure.macu.com/#/signup?loanType=ACCOUNT_OPENING"
  }), React.createElement(BarItem, {
    label: "ROUTING NUMBER",
    link: "/help/answers/act/what-is-mountain-america-credit-unions-aba-routing-number"
  })))), "\n", React.createElement(Content, {
    noBorder: true,
    className: "px-xl-6 px-lg-5 px-4 py-6 overflow-hidden rates-container"
  }, React.createElement(RatesList, {
    heading: "Rates",
    ctaText: "See all rates",
    ctaHyperLink: "/rates"
  }, React.createElement(RatesCategory, {
    categoryTitle: "Most Popular"
  }, React.createElement(RateCard, {
    rateId: "31",
    headline: "Certificate",
    subhead: "18-month",
    ctaText: "Learn more",
    ctaHyperLink: "/accounts/savings/certificate-accounts"
  }), React.createElement(RateCard, {
    rateId: 8,
    headline: "New & used car loans",
    subhead: "60-month",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/vehicle-loans/auto"
  }), React.createElement(RateCard, {
    rateId: 18,
    headline: "Fixed-rate mortgage",
    subhead: "15-year",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/home-loans/conventional"
  }), React.createElement(RateCard, {
    rateId: 17,
    headline: "Fixed-rate mortgage",
    subhead: "30-year",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/home-loans/conventional"
  })), React.createElement(RatesCategory, {
    categoryTitle: "Certificates"
  }, React.createElement(RateCard, {
    rateId: 29,
    headline: "Certificate",
    subhead: "6-month",
    ctaText: "Learn more",
    ctaHyperLink: "/accounts/savings/certificate-accounts"
  }), React.createElement(RateCard, {
    rateId: 30,
    headline: "Certificate",
    subhead: "12-month",
    ctaText: "Learn more",
    ctaHyperLink: "/accounts/savings/certificate-accounts"
  }), React.createElement(RateCard, {
    rateId: "31",
    headline: "Certificate",
    subhead: "18-month",
    ctaText: "Learn more",
    ctaHyperLink: "/cp/savings-certificates/18-month-certificate"
  }), React.createElement(RateCard, {
    rateId: 36,
    headline: "Certificate",
    subhead: "60-month",
    ctaText: "Learn more",
    ctaHyperLink: "/accounts/savings/certificate-accounts"
  })), React.createElement(RatesCategory, {
    categoryTitle: "Mortgage"
  }, React.createElement(RateCard, {
    rateId: 18,
    headline: "Fixed rate ",
    subhead: "15-year",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/home-loans/conventional"
  }), React.createElement(RateCard, {
    rateId: 17,
    headline: "Fixed rate",
    subhead: "30-year ",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/home-loans/conventional"
  }), React.createElement(RateCard, {
    rateId: 19,
    headline: "100% First-time",
    subhead: "Homebuyer",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/home-loans/first-time-homebuyer"
  }), React.createElement(RateCard, {
    rateId: 42,
    headline: "Construction",
    subhead: "One- or two-step close",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/home-loans/construction"
  })), React.createElement(RatesCategory, {
    categoryTitle: "Auto + RV"
  }, React.createElement(RateCard, {
    rateId: 8,
    headline: "New & used car loans",
    subhead: "60-month",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/vehicle-loans/auto"
  }), React.createElement(RateCard, {
    rateId: "9",
    headline: "New car loans",
    subhead: "72-month",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/vehicle-loans/auto"
  }), React.createElement(RateCard, {
    rateId: 115,
    headline: "New RV loans",
    subhead: "180-month",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/vehicle-loans/rv"
  }), React.createElement(RateCard, {
    rateId: 77,
    headline: "Small RV & ATV loans",
    subhead: "72-month",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/vehicle-loans/side-by-side"
  })), React.createElement(RatesCategory, {
    categoryTitle: "Credit Cards"
  }, React.createElement(RateCard, {
    rateId: 24,
    headline: "Low Rate",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/visa-credit-cards/low-rate-card"
  }), React.createElement(RateCard, {
    rateId: 25,
    headline: "Rewards",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/visa-credit-cards/rewards-card"
  }), React.createElement(RateCard, {
    rateId: 61,
    headline: "Cash Back",
    ctaText: "Learn more",
    ctaHyperLink: "/loans/visa-credit-cards/cash-back-card"
  }))), React.createElement(Row, null, React.createElement(Column, null, React.createElement(Markup, {
    html: "<span>‡<small>Annual Percentage Yield (APY). Annual Percentage Rate (APR).</small></span>"
  })))), "\n", React.createElement(Jumbotron, {
    className: "bg-redGradient"
  }, React.createElement(Content, {
    noBorder: true,
    className: "bg-transparent"
  }, React.createElement(Row, null, React.createElement(Column, {
    className: "col-lg-5 p-0 overflow-hidden d-flex"
  }, React.createElement(Markup, {
    html: "  <img style=\"width: 100%; height: 100%; object-fit: cover;\" src=\"https://www.macu.com/media/inline/inline-employee-1200x800.jpg\" alt=\"Happy bank teller\" />"
  })), React.createElement(Column, {
    className: "col-lg-7 p-xl-6 p-lg-5 py-5 px-4  text-white"
  }, React.createElement(Markup, {
    html: "<h2>Placing members first</h2>        <p class=\"mb-5\">Mountain America Credit Union opened its doors in the 1930s with a simple goal—to help our fellow members financially. Today, that spirit of cooperation still drives us. As a not-for-profit financial institution, our focus is to guide members toward financial success. We do this through a combination of affordable products, friendly service, community involvement and financial education. At Mountain America, you have access to a full suite of financial services, including savings accounts, auto loans, checking accounts, credit cards, SBA loans, business checking, retirement planning and more. Plus, your accounts are always close at hand with our mobile app, online banking and more than 100 branches, spanning Utah, Idaho, Montana, Nevada and Arizona.<br/> <br/>As your financial partner, we’re dedicated to preparing you for the road ahead. Let’s make the journey together. </p>          <ul class=\"small\" style=\"list-style-type:none; padding:0; margin:0;\">  <li class=\"mb-3\"><a class=\"text-white btn btn-underline-light text-uppercase\" style=\"text-decoration:none;\" href=\"/branch-locations\">Find a branch</a></li>  <li class=\"mb-3\"><a class=\"text-white btn btn-underline-light text-uppercase\" style=\"text-decoration:none;\" href=\"https://secure.macu.com/#/signup?loanType=ACCOUNT_OPENING&productId=B51\">Become a member</a></li>  <li class=\"mb-3\"><a class=\"text-white btn btn-underline-light text-uppercase\" style=\"text-decoration:none;\" href=\"/services/online-banking\">Mobile + online banking</a></li></ul>  <div id=\"newRelic_home\" style=\"display:none\"></div>",
    cssStyle: ".this{    }",
    javascript: "var gTg = document.createElement(\'div\');\ngTg.id = \'gTg\';\ngTg.className = \'d-none\';\ngTg.innerHTML = \'&nbsp;\';\ndocument.body.appendChild(gTg);",
    runScript: true
  }))))), "\n", React.createElement(Jumbotron, {
    className: "bg-topo"
  }, React.createElement(Content, {
    noBorder: true,
    className: "px-xl-6 px-lg-5 px-4 bg-transparent py-6"
  }, React.createElement(VideoPullquote, {
    videoId: "1DdfQNVTy1w",
    src: "/video-thumbnails/video-mystyle-3-up-influencer.jpg",
    autoPlay: true,
    className: "mx-4 mx-xxl-0",
    alt: "Make MyStyle your lifestyle"
  }))), "\n", React.createElement(Content, {
    noBorder: true
  }, React.createElement(Row, null, React.createElement(Column, {
    className: "mt-xl-8 mt-6 mb-5"
  }, React.createElement(Markup, {
    html: "<h2 id=\"popular-offers\">Popular offers</h2>"
  })))), "\n", React.createElement(Content, {
    noBorder: true
  }, React.createElement(Row, null, React.createElement(CardDeck, {
    cardType: "SolidColorPhoto",
    className: "px-xl-6 px-lg-5 px-4",
    cardClassName: "mb-3",
    desktopColumns: 3,
    tabletColumns: 2,
    mobileColumns: 1
  }, React.createElement(Card, {
    cardImage: "/thumbnails/cards/solid/card-heloc-intro-rate-2025.jpg",
    cardTitle: "Limited-time HELOC offer",
    cardBody: "<span>Get an intro rate of 4.49% APR for six months—then as low as {{TabbedRates.20.rate.initialRate,2}}% variable APR.</span>",
    cardFooter: "<a class=\"btn btn-outline-light\" href=\"/loans/home-equity/heloc\">See how</a>",
    backgroundColor: "bg-cedar",
    cardAlt: "Woman painting a wall"
  }), React.createElement(Card, {
    cardImage: "/thumbnails/cards/solid/card-solid-auto-fall-2025.jpg",
    cardTitle: "Special low auto rate",
    cardBody: "<span>Save money on your car payments. Get a {{TabbedRates.8.rate.initialRate,2}}% APR auto loan for a limited time.</span>",
    cardFooter: "<a class=\"btn btn-outline-light\" href=\"/loans/vehicle-loans/auto\">Calculate your payments</a>",
    backgroundColor: "bg-redRock",
    cardAlt: "Woman getting out of her car"
  }), React.createElement(Card, {
    cardImage: "/thumbnails/cards/solid/card-mystyle-la-morena-2025.jpg",
    cardTitle: "MyStyle® Checking",
    cardBody: "<span>Get a checking account with built-in lifelines made for your lifestyle. </span>",
    cardFooter: "<a class=\"btn btn-outline-light\" href=\"/accounts/checking/mystyle-checking\">SEE ALL THE BENEFITS</a>",
    backgroundColor: "bg-galaxy",
    cardAlt: "La Morena standing by a graffiti mural"
  }))), React.createElement(Schema, {
    jsonSchema: "{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"Organization\",\n  \"name\": \"Mountain America Credit Union\",\n  \"alternateName\": \"Mountain America\",\n  \"url\": \"https://www.macu.com\",\n  \"image\": \"https://www.macu.com/media/Images/alondra-1200x800.jpg\",\n  \"logo\": \"https://www.macu.com/media/logos/header_logo.svg\",\n  \"sameAs\": [\n    \"https://www.facebook.com/MountainAmerica/\",\n    \"https://twitter.com/MountainAmerica\",\n    \"https://www.instagram.com/mountainamericacu/\",\n    \"https://www.youtube.com/user/mountainamerica\",\n    \"https://www.linkedin.com/company/mountain-america-credit-union/\"\n  ]\n}"
  })));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
